import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

/**
 * Holdings Entity Definition
 *
 * Defines the structure and validation rules for holdings data imports.
 * This template is used for mapping external data to the WealthBee holdings format.
 *
 * @type {ImportTemplateField[]} Array of field definitions for holdings imports
 */
export const Holding: ImportTemplateField[] = [
  {
    toField: "holdingKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "baseAmount", // Base amount of the transaction
    fromField: "",
    dataType: DataType.decimal,
    required: true, // Amount is required for valuation
    precision: 2, // Two decimal places for currency precision
  },
  {
    toField: "currency", // Currency of the transaction
    fromField: "",
    dataType: DataType.string,
    required: true, // Currency is required for proper accounting
  },
  {
    toField: "quantity", // Quantity of securities traded
    fromField: "",
    dataType: DataType.decimal,
    required: true, // Quantity is required for position calculations
    precision: 2, // Allow for fractional shares
  },
  {
    toField: "accountKey", // Account identifier
    fromField: "",
    dataType: DataType.string,
    required: true, // Account key is required to identify the account
  },
  {
    toField: "instrumentKey", // Description or notes about the transaction
    fromField: "",
    dataType: DataType.string,
    required: false,
  },
];
